import { Directive, input, numberAttribute, Signal, InputSignal } from '@angular/core';
import { InputDirective } from '../input/input.directive';

type RangeInput = string | number | null;
/**
 * RangeInputDirective
 * Serves to provide typings to programmatically manipulate the <input type=range>
 */
@Directive({
  selector: 'input[tdWbRangeInput]',
  exportAs: 'tdWbRangeInput'
})
export class RangeInputDirective extends InputDirective {
  // Numeric configuration as signal inputs with transforms
  step: Signal<number>  = input<number, RangeInput>(1, { transform: (v: string | number) => numberAttribute(v, 1) });
  min: Signal<number>  = input<number, RangeInput>(1, { transform: (v: string | number) => numberAttribute(v, 1) });
  max: Signal<number>  = input<number, RangeInput>(1, { transform: (v: string | number) => numberAttribute(v, 1) });

  // Identifier and value as signals to comply with migration requirements
  id: InputSignal<string> = input<string | undefined>(undefined);
}
